var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{staticClass:"nostrokepath"},[_c('path',{attrs:{"d":"M5 9L12 16L19 9H5Z","fill":"#3C4043"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }